import { Field } from 'react-final-form'
import React from 'react'
import styled from 'styled-components'
import {
  DatePicker
} from '@material-ui/pickers';

const StyledDatePicker = styled(DatePicker)`
  height: auto;
  .MuiInputBase-root{
    background-color: rgb(242, 245, 250);
  }

  .MuiFilledInput-underline:before{
    border-bottom: 1px solid transparent;
  }

  @media only screen and (max-width: 650px) {

    }
`

const DatePickerField = ({
  id,
  type,
  name,
  label,
  helperText,
  variant,
  validate,
  InputProps,
  ...props
}) => {
  return (
    <Field
      name={name}
      type={type}
      validate={validate}
    >
      {({ input, meta }) => {
        return (
          <StyledDatePicker
            id={id}
            label={label}
            helperText={meta.error && meta.touched ? meta.error : helperText}
            InputProps={InputProps}
            error={meta.error && meta.touched}
            {...props}
            {...input}
            openTo='year'
            views={["year", "month"]}
            inputVariant='outlined'
          />
          )
      }}
    </Field>
  )
}

export default DatePickerField
